"use client";
import * as React from 'react';
import { buttonWrapper, language, separator, wrapper, popover } from './styles.js';
import { IconButton } from '../../IconButton/IconButton.web.js';
import { IconEarthGlobe } from '../../icons/features/IconEarthGlobe.web.js';
import { ThemeProvider } from 'styled-components';
import { colors } from '../../constants/colors.js';
import { usePopover } from '../../Popover/utils.web.js';
import { useTheme } from '../../utils/theming/useTheme.js';
import { Hidden } from '../../Hidden/Hidden.web.js';

/**
 * @deprecated -- Please do not use this component. It is deprecated and will be removed in the future is no longer receiving updates.
 */
var LanguageWidget = function LanguageWidget(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'inherit' : _ref$color,
    _ref$hoverColor = _ref.hoverColor,
    hoverColor = _ref$hoverColor === undefined ? colors.oceanGreen : _ref$hoverColor,
    _ref$highlightColor = _ref.highlightColor,
    highlightColor = _ref$highlightColor === undefined ? colors.oceanGreen : _ref$highlightColor,
    languages = _ref.languages,
    selected = _ref.selected,
    onSelect = _ref.onSelect;
  var popover$1 = usePopover();

  // TODO: useless useCallback, as we end up passing inner arrow function to styled.language
  var handleSelect = React.useCallback(function (language) {
    return function () {
      if (onSelect) onSelect(language);
    };
  }, [onSelect]);
  var notSelected = languages.filter(function (language) {
    return language !== selected;
  });
  var theme = useTheme();
  var buttons = /*#__PURE__*/React.createElement(buttonWrapper, null, notSelected.map(function (language$1, index) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: language$1
    }, /*#__PURE__*/React.createElement(language, {
      "data-testid": "elemental-LanguageWidget-".concat(language$1),
      onClick: handleSelect(language$1),
      $color: color,
      $hoverColor: hoverColor
    }, language$1.toUpperCase()), index !== notSelected.length - 1 ? /*#__PURE__*/React.createElement(separator, null) : null);
  }));
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(wrapper, {
    "data-testid": "elemental-LanguageWidget"
  }, /*#__PURE__*/React.createElement(Hidden, {
    below: "l"
  }, buttons), /*#__PURE__*/React.createElement(Hidden, {
    above: "l"
  }, /*#__PURE__*/React.createElement(IconButton, {
    "data-testid": "elemental-LanguageWidget-open",
    icon: /*#__PURE__*/React.createElement(IconEarthGlobe, {
      size: 24
    }),
    color: highlightColor,
    status: "plain",
    size: 32,
    onClick: popover$1.handleOpen
  }), /*#__PURE__*/React.createElement(popover, {
    onClose: popover$1.handleClose,
    anchor: popover$1.anchor,
    opened: popover$1.open,
    anchorPos: "top-end",
    backgroundColor: colors.lightGrey
  }, buttons))));
};

export { LanguageWidget };
